const myAccessRequests = {
  errors: {
    loadFailed: "Ekki tókst að sækja aðgangsbeiðnir",
  },
  status: {
    pendingEmailVerification: {
      badge: "Bíður staðfestingar tölvupósts",
      message:
        "Staðfestu netfangið þitt til að ljúka við aðgangsbeiðnina.",
    },
    pending: {
      badge: "Í yfirferð",
      message: "Beiðnin þín er í yfirferð hjá verkefnisstjóra.",
    },
    approved: {
      badge: "Samþykkt",
      message: "Aðgangsbeiðnin þín hefur verið samþykkt!",
    },
    rejected: {
      badge: "Hafnað",
      message: "Aðgangsbeiðnin þín var ekki samþykkt.",
    },
  },
  title: "Beiðnir um aðild að verkefni",
  subtitle: "Staðan á beiðnum þínum um aðild að verkefni",
  empty: {
    noRequests: "Engar aðgangsbeiðnir fundust",
    hint: "Skráðu þig eða óskaðu eftir aðgangi að verkefni til að byrja",
  },
  request: {
    heading: "Aðgangsbeiðni #{{id}}",
    projectInterest: "Áhugavert verkefni:",
    submitted: "Send inn:",
  },
  approvedDetails: {
    heading: "Samþykkt fyrir verkefni",
    role: "Hlutverk:",
    approvedOn: "Samþykkt þann {{date}}",
    notes: "Athugasemdir:",
  },
  rejectedDetails: {
    heading: "Beiðni ekki samþykkt",
    reviewedOn: "Yfirfarið þann {{date}}",
    reason: "Ástæða:",
  },
};

export default myAccessRequests;
